<div id="banner" class="alert d-flex flex-row align-items-center" [ngClass]="'alert-'+ _type">
    <mat-icon class="m-3">{{_icon}}</mat-icon>

    <div class="pt-3 pb-3 pe-2"[innerHtml]="_bannerText"></div>
</div>